import Versions from './Versions.container';
export default Versions;